import { useEffect, useState } from 'react';

export const useDeviceWidth = () => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    let timeoutId: number;

    if (!width) {
      setWidth(window.innerWidth);
    }

    const resizeListener = () => {
      clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => setWidth(window.innerWidth), 150);
    };

    window.addEventListener('resize', resizeListener);

    return () => window.removeEventListener('resize', resizeListener);
  }, [width]);

  return width;
};
